// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c45ffb03","707":"0a1367eb","818":"eec73156","898":"671f08df","933":"dbe12243","961":"b8281fa1"}[chunkId] + ".chunk.js";
};